// extracted by mini-css-extract-plugin
module.exports = {"container":"ViewDetailsButton_container__5kuka","button":"ViewDetailsButton_button__igJRe"};